module.exports = __webpack_public_path__ + "img/57_26.b390d8ad.png";